const HTMLQuestions = {
	jun: [
		{
			question: 'Чем отличается элемент <ul> от <ol>?',
			option: {
				a1: 'Ничем',
				a2: '<ul> имеет маркированный тип, а <ol> - нумерованный',
				a3: '<ul> создает упорядоченный список, а <ol> - неупорядоченный',
				a4: '<ul> имеет нумерованный тип, а <ol> - маркированный',
			},
			answerOption: 'a2',
			answer: 'Тег <ul> имеет маркированный (неупорядоченный) тип списка,\n' +
				'а <ol> - нумерованный.',
			num: '#1',
		},
		{
			question: 'Что означает аббревиатура HTML?',
			option: {
				a1: 'язык гипертекстовой разметки',
				a2: 'язык программирования текстовой разметки',
				a3: 'технология размещения текстовых символов в сети интернет',
				a4: 'гипер-трансферный метод интерполяции языка в текст',
			},
			answerOption: 'a1',
			answer: 'HTML (от англ. HyperText Markup Language — «язык гипертекстовой\n' +
				'разметки»). Стандартизированный язык разметки веб-страниц.',
			num: '#2',
		},
		{
			question: 'Для чего используется элемент <!DOCTYPE...>?',
			option: {
				a1: 'Элемент указывают больше по традиции, практической пользы нет',
				a2: 'Элемент предназначен для указания начала текущего документа',
				a3: 'Элемент предназначен для указания типа текущего документа',
				a4: 'Элемент предназначен для указания типа документа, если используется переходный синтаксис',
			},
			answerOption: 'a3',
			answer: 'Элемент <!DOCTYPE html> указывает браузеру, что документ использует HTML5.\n'
				+ 'Это необходимо для корректного отображения страницы в режиме соответствия стандартам (standards mode).',
			num: '#3',
		},
		{
			question: 'Что означает элемент <meta charset="UTF-8">?',
			option: {
				a1: 'Устанавливает язык документа',
				a2: 'Устанавливает кодировку документа - ISO-8859-1',
				a3: 'Устанавливает кодировку документа - UTF-8',
				a4: 'Определяет набор символов для валидации форм',
			},
			answerOption: 'a3',
			answer: 'Устанавливает универсальную кодировку документа - UTF-8',
			num: '#4',
		},
		{
			question: 'Какой тег используется для создания гиперссылки?',
			option: {
				a1: '<link>',
				a2: '<a>',
				a3: '<href>',
				a4: '<url>',
			},
			answerOption: 'a2',
			answer: 'Тег <a> (anchor) используется для создания гиперссылок. Атрибут href\n' +
				'указывает адрес ссылки.',
			num: '#5',
		},
		{
			question: 'Какой атрибут тега <img> является обязательным?',
			option: {
				a1: 'width',
				a2: 'height',
				a3: 'src',
				a4: 'title',
			},
			answerOption: 'a3',
			answer: 'Атрибут src (source) является обязательным для тега <img>, так как он\n' +
				'указывает путь к изображению.',
			num: '#6',
		},
		{
			question: 'Какой тег используется для создания таблицы?',
			option: {
				a1: '<table>',
				a2: '<tab>',
				a3: '<grid>',
				a4: '<tbody>',
			},
			answerOption: 'a1',
			answer: 'Тег <table> является контейнером для создания таблиц в HTML.',
			num: '#7',
		},
		{
			question: 'Чем отличается тег <div> от <span>?',
			option: {
				a1: 'Ничем, это синонимы',
				a2: '<div> - блочный элемент, <span> - строчный',
				a3: '<div> - строчный элемент, <span> - блочный',
				a4: '<div> используется только для текста',
			},
			answerOption: 'a2',
			answer: '<div> является блочным элементом (занимает всю ширину), а <span> -\n' +
				'строчным элементом (занимает только необходимую ширину).',
			num: '#8',
		},
		{
			question: 'Какой тег используется для создания заголовка первого уровня?',
			option: {
				a1: '<header>',
				a2: '<h1>',
				a3: '<title>',
				a4: '<head>',
			},
			answerOption: 'a2',
			answer: 'Тег <h1> используется для создания заголовка первого (самого важного)\n' +
				'уровня. Всего существует 6 уровней заголовков от <h1> до <h6>.',
			num: '#9',
		},
		{
			question: 'Какой атрибут делает текстовое поле обязательным для заполнения?',
			option: {
				a1: 'mandatory',
				a2: 'required',
				a3: 'validate',
				a4: 'important',
			},
			answerOption: 'a2',
			answer: 'Атрибут required делает поле формы обязательным для заполнения перед\n' +
				'отправкой.',
			num: '#10',
		},
		{
			question: 'Какой тег используется для создания абзаца?',
			option: {
				a1: '<paragraph>',
				a2: '<p>',
				a3: '<text>',
				a4: '<br>',
			},
			answerOption: 'a2',
			answer: 'Тег <p> (paragraph) используется для создания абзацев текста.',
			num: '#11',
		},
		{
			question: 'Что делает тег <br>?',
			option: {
				a1: 'Создает жирный текст',
				a2: 'Создает перенос строки',
				a3: 'Создает границу вокруг элемента',
				a4: 'Создает разрыв страницы',
			},
			answerOption: 'a2',
			answer: 'Тег <br> (break) создает перенос строки внутри текста. Это одиночный\n' +
				'тег, не требующий закрывающего тега.',
			num: '#12',
		},
		{
			question: 'Какой тег используется для создания выпадающего списка в форме?',
			option: {
				a1: '<dropdown>',
				a2: '<list>',
				a3: '<select>',
				a4: '<option>',
			},
			answerOption: 'a3',
			answer: 'Тег <select> создает выпадающий список, а внутри него используются\n' +
				'теги <option> для каждого пункта списка.',
			num: '#13',
		},
		{
			question: 'Какой атрибут тега <a> открывает ссылку в новой вкладке?',
			option: {
				a1: 'newtab',
				a2: 'target="_blank"',
				a3: 'window="new"',
				a4: 'open="tab"',
			},
			answerOption: 'a2',
			answer: 'Атрибут target="_blank" открывает ссылку в новой вкладке или окне\n' +
				'браузера.',
			num: '#14',
		},
		{
			question: 'Какой тег используется для создания кнопки?',
			option: {
				a1: '<btn>',
				a2: '<input type="button">',
				a3: '<button>',
				a4: 'Оба варианта a2 и a3 верны',
			},
			answerOption: 'a4',
			answer: 'Для создания кнопки можно использовать как тег <button>, так и <input\n' +
				'type="button">. Тег <button> более гибкий и позволяет вставлять внутрь\n' +
				'HTML-содержимое.',
			num: '#15',
		},
		{
			question: 'Что означает атрибут alt у тега <img>?',
			option: {
				a1: 'Альтернативный путь к изображению',
				a2: 'Альтернативный текст, если изображение не загрузилось',
				a3: 'Высота изображения',
				a4: 'Выравнивание изображения',
			},
			answerOption: 'a2',
			answer: 'Атрибут alt (alternative) содержит альтернативный текст, который\n' +
				'отображается, если изображение не загрузилось, а также используется\n' +
				'программами чтения с экрана для людей с ограниченными возможностями.',
			num: '#16',
		},
		{
			question: 'Какой тег может визуально отображать текст жирным начертанием?',
			option: {
				a1: '<bold>',
				a2: '<b>',
				a3: '<strong>',
				a4: 'Оба варианта a2 и a3 верны',
			},
			answerOption: 'a4',
			answer: 'Для создания жирного текста используются теги <b> (bold) и <strong>.\n' +
				'Разница в том, что <strong> имеет семантическое значение (важный текст),\n' +
				'а <b> - только визуальное.',
			num: '#17',
		},
		{
			question: 'Какой тег используется для создания формы?',
			option: {
				a1: '<form>',
				a2: '<input>',
				a3: '<fieldset>',
				a4: '<submit>',
			},
			answerOption: 'a1',
			answer: 'Тег <form> является контейнером для создания форм. Внутри него\n' +
				'размещаются элементы ввода данных.',
			num: '#18',
		},
		{
			question: 'Какой тег используется для создания многострочного текстового поля?',
			option: {
				a1: '<input type="text">',
				a2: '<textarea>',
				a3: '<textfield>',
				a4: '<multiline>',
			},
			answerOption: 'a2',
			answer: 'Тег <textarea> создает многострочное текстовое поле для ввода большого\n' +
				'объема текста.',
			num: '#19',
		},
		{
			question: 'Что делает атрибут placeholder в элементах формы?',
			option: {
				a1: 'Устанавливает значение по умолчанию',
				a2: 'Показывает подсказку внутри поля ввода',
				a3: 'Блокирует поле для редактирования',
				a4: 'Устанавливает максимальную длину текста',
			},
			answerOption: 'a2',
			answer: 'Атрибут placeholder показывает текст-подсказку внутри поля ввода,\n' +
				'который исчезает при начале ввода.',
			num: '#20',
		},
		{
			question: 'Как правильно вставить комментарий в HTML?',
			option: {
				a1: '// Это комментарий',
				a2: '/* Это комментарий */',
				a3: '<!-- Это комментарий -->',
				a4: '<comment>Это комментарий</comment>',
			},
			answerOption: 'a3',
			answer: 'Комментарии в HTML оформляются с помощью синтаксиса\n' +
				'<!-- комментарий -->. Они не отображаются в браузере.',
			num: '#21',
		},
		{
			question: 'Какой тег используется для вставки горизонтальной линии?',
			option: {
				a1: '<line>',
				a2: '<hr>',
				a3: '<br>',
				a4: '<divider>',
			},
			answerOption: 'a2',
			answer: 'Тег <hr> (horizontal rule) создаёт горизонтальную линию-разделитель\n' +
				'между блоками контента. Это одиночный тег.',
			num: '#22',
		},
		{
			question: 'Где правильно размещать тег <title>?',
			option: {
				a1: 'Внутри <body>',
				a2: 'Внутри <head>',
				a3: 'В любом месте документа',
				a4: 'Внутри <header>',
			},
			answerOption: 'a2',
			answer: 'Тег <title> должен находиться внутри <head>. Он определяет\n' +
				'заголовок вкладки браузера и отображается в результатах поиска.',
			num: '#23',
		},
		{
			question: 'Что произойдёт, если не закрыть тег <p>?',
			option: {
				a1: 'Страница не загрузится',
				a2: 'Браузер выдаст ошибку',
				a3: 'Браузер автоматически закроет тег при парсинге',
				a4: 'Текст исчезнет',
			},
			answerOption: 'a3',
			answer: 'Браузер автоматически закроет незакрытые теги вроде <p> во время\n' +
				'парсинга DOM. Однако рекомендуется всегда закрывать теги явно.',
			num: '#24',
		},
		{
			question: 'Какой тег используется для отображения цитаты?',
			option: {
				a1: '<quote>',
				a2: '<q>',
				a3: '<blockquote>',
				a4: 'Оба варианта a2 и a3 верны',
			},
			answerOption: 'a4',
			answer: 'Короткие цитаты в строке оформляются тегом <q>, а длинные,\n' +
				'блочные — тегом <blockquote>. Оба являются валидными для цитирования.',
			num: '#25',
		},
		{
			question: 'Какой тег используется для вставки изображения?',
			option: {
				a1: '<img>',
				a2: '<image>',
				a3: '<picture>',
				a4: '<source>',
			},
			answerOption: 'a1',
			answer: 'Тег <img> — основной способ вставки изображения. Это одиночный\n' +
				'тег, обязательный атрибут — src. Атрибут alt рекомендуется всегда.',
			num: '#26',
		},
		{
			question: 'Что делает тег <head>?',
			option: {
				a1: 'Отображает шапку сайта',
				a2: 'Содержит метаданные документа, не отображаемые на странице',
				a3: 'Создаёт заголовок первого уровня',
				a4: 'Группирует навигационные ссылки',
			},
			answerOption: 'a2',
			answer: 'Тег <head> содержит метаданные: заголовок, кодировку, стили,\n' +
				'скрипты и другую служебную информацию, не видимую пользователю.',
			num: '#27',
		},
		{
			question: 'Какой тег создаёт нумерованный список?',
			option: {
				a1: '<ul>',
				a2: '<ol>',
				a3: '<li>',
				a4: '<list>',
			},
			answerOption: 'a2',
			answer: 'Тег <ol> (ordered list) создаёт нумерованный список. Элементы\n' +
				'списка оформляются с помощью тега <li>.',
			num: '#28',
		},
		{
			question: 'Можно ли вкладывать тег <div> внутрь тега <p>?',
			option: {
				a1: 'Да, всегда',
				a2: 'Нет, браузер закроет <p> автоматически',
				a3: 'Только если <div> пустой',
				a4: 'Только в HTML5',
			},
			answerOption: 'a2',
			answer: 'Нет. Тег <p> может содержать только строчные элементы.\n' +
				'При попытке вложить блочный элемент, например <div>, браузер\n' +
				'автоматически закроет <p> перед ним.',
			num: '#29',
		},
		{
			question: 'Для чего используется тег <meta name="viewport">?',
			option: {
				a1: 'Для подключения стилей',
				a2: 'Для настройки отображения на мобильных устройствах',
				a3: 'Для указания автора страницы',
				a4: 'Для валидации формы',
			},
			answerOption: 'a2',
			answer: 'Тег <meta name="viewport"> управляет масштабированием и\n' +
				'отображением страницы на мобильных устройствах. Обычно задаётся как\n' +
				'width=device-width, initial-scale=1.',
			num: '#30',
		},
	],
	mid: [
		{
			question: 'Чем отличается <section> от <article> в HTML5?',
			option: {
				a1: 'Ничем, это синонимы',
				a2: '<section> - тематическая группировка, <article> - независимый контент',
				a3: '<section> используется только в <header>',
				a4: '<article> не может содержать <section>',
			},
			answerOption: 'a2',
			answer: '<section> используется для тематической группировки контента, а\n' +
				'<article> представляет независимый, самодостаточный контент, который\n' +
				'можно распространять отдельно (статья, пост в блоге).',
			num: '#31',
		},
		{
			question: 'Что такое data-атрибуты и для чего они используются?',
			option: {
				a1: 'Атрибуты для хранения данных в базе данных',
				a2: 'Пользовательские атрибуты для хранения данных в HTML-элементах',
				a3: 'Атрибуты для валидации форм',
				a4: 'Атрибуты для SEO-оптимизации',
			},
			answerOption: 'a2',
			answer: 'Data-атрибуты (data-*) позволяют хранить пользовательские данные в\n' +
				'HTML-элементах без использования нестандартных атрибутов. Доступ к ним\n' +
				'можно получить через JavaScript с помощью dataset.',
			num: '#32',
		},
		{
			question: 'В чем разница между атрибутами defer и async у тега <script>?',
			option: {
				a1: 'Ничем не отличаются',
				a2: 'defer выполняет скрипт после загрузки DOM, async - сразу после загрузки скрипта',
				a3: 'async выполняет скрипт после загрузки DOM, defer - сразу',
				a4: 'defer используется только для внешних скриптов',
			},
			answerOption: 'a2',
			answer: 'defer загружает скрипт параллельно и выполняет после полной загрузки\n' +
				'DOM в порядке объявления. async загружает параллельно и выполняет сразу\n' +
				'после загрузки, прерывая парсинг HTML.',
			num: '#33',
		},
		{
			question: 'Какой тег используется для встраивания SVG-графики непосредственно в HTML?',
			option: {
				a1: '<img src="file.svg">',
				a2: '<svg>',
				a3: '<vector>',
				a4: '<graphic>',
			},
			answerOption: 'a2',
			answer: 'Тег <svg> позволяет встраивать векторную графику непосредственно в\n' +
				'HTML-документ, что дает возможность управлять элементами через CSS и\n' +
				'JavaScript.',
			num: '#34',
		},
		{
			question: 'Что делает атрибут contenteditable?',
			option: {
				a1: 'Скрывает содержимое элемента',
				a2: 'Делает содержимое элемента редактируемым',
				a3: 'Защищает содержимое от копирования',
				a4: 'Устанавливает тип контента',
			},
			answerOption: 'a2',
			answer: 'Атрибут contenteditable="true" делает содержимое HTML-элемента\n' +
				'редактируемым пользователем прямо в браузере, превращая элемент в\n' +
				'текстовый редактор.',
			num: '#35',
		},
		{
			question: 'Какой тег используется для создания прогресс-бара в HTML5?',
			option: {
				a1: '<progressbar>',
				a2: '<progress>',
				a3: '<meter>',
				a4: '<loading>',
			},
			answerOption: 'a2',
			answer: 'Тег <progress> создает индикатор выполнения задачи. Атрибуты value и\n' +
				'max определяют текущее и максимальное значение. Тег <meter> используется\n' +
				'для отображения измерений в известном диапазоне.',
			num: '#36',
		},
		{
			question: 'Что такое Shadow DOM и для чего он используется?',
			option: {
				a1: 'Скрытая часть DOM для хранения данных',
				a2: 'Инкапсулированное DOM-дерево внутри элемента',
				a3: 'Виртуальный DOM для оптимизации',
				a4: 'Копия основного DOM',
			},
			answerOption: 'a2',
			answer: 'Shadow DOM — это изолированное DOM-дерево, прикреплённое к\n' +
				'элементу как часть Web Components, но отделенное от основного DOM.\n' +
				'Оно инкапсулирует разметку и стили, предотвращая конфликты с основным документом.',
			num: '#37',
		},
		{
			question: 'Какой атрибут формы отключает встроенную валидацию HTML5?',
			option: {
				a1: 'validate="false"',
				a2: 'novalidate',
				a3: 'validation="off"',
				a4: 'disable-validation',
			},
			answerOption: 'a2',
			answer: 'Атрибут novalidate у тега <form> отключает встроенную валидацию HTML5,\n' +
				'позволяя реализовать собственную логику проверки данных.',
			num: '#38',
		},
		{
			question: 'Чем отличается <template> от обычного скрытого элемента?',
			option: {
				a1: 'Ничем не отличается',
				a2: '<template> не рендерится и его содержимое не активно до клонирования',
				a3: '<template> используется только для CSS',
				a4: '<template> автоматически клонируется при загрузке',
			},
			answerOption: 'a2',
			answer: 'Содержимое <template> не рендерится браузером, скрипты не выполняются,\n' +
				'изображения не загружаются. Контент активируется только после\n' +
				'клонирования через JavaScript.',
			num: '#39',
		},
		{
			question: 'Какой тег используется для группировки опций в <select>?',
			option: {
				a1: '<group>',
				a2: '<optgroup>',
				a3: '<fieldset>',
				a4: '<options>',
			},
			answerOption: 'a2',
			answer: 'Тег <optgroup> группирует связанные опции в выпадающем списке\n' +
				'<select>, создавая визуальные разделы с заголовками через атрибут label.',
			num: '#40',
		},
		{
			question: 'Что делает атрибут loading="lazy" у тега <img>?',
			option: {
				a1: 'Замедляет загрузку изображения',
				a2: 'Откладывает загрузку изображения до приближения к области видимости',
				a3: 'Загружает изображение в низком качестве',
				a4: 'Блокирует загрузку изображения',
			},
			answerOption: 'a2',
			answer: 'Атрибут loading="lazy" реализует отложенную загрузку изображений - они\n' +
				'загружаются только когда пользователь прокручивает страницу к ним, что\n' +
				'улучшает производительность.',
			num: '#41',
		},
		{
			question: 'Какой тег используется для определения аббревиатуры или акронима?',
			option: {
				a1: '<abbr>',
				a2: '<acronym>',
				a3: '<short>',
				a4: '<abbreviation>',
			},
			answerOption: 'a1',
			answer: 'Тег <abbr> используется для разметки аббревиатур и акронимов. Атрибут\n' +
				'title содержит полную расшифровку, которая отображается при наведении.',
			num: '#42',
		},
		{
			question: 'В чем разница между <input type="submit"> и <button type="submit">?',
			option: {
				a1: 'Нет разницы',
				a2: '<button> может содержать HTML-разметку внутри',
				a3: '<input> более современный',
				a4: '<button> не может отправлять формы',
			},
			answerOption: 'a2',
			answer: '<button> более гибкий - может содержать HTML-разметку (изображения,\n' +
				'иконки), имеет открывающий и закрывающий теги. <input> - одиночный тег с\n' +
				'текстом только в атрибуте value.',
			num: '#43',
		},
		{
			question: 'Что такое семантическая разметка и почему она важна?',
			option: {
				a1: 'Разметка для SEO-оптимизации',
				a2: 'Использование тегов по их смысловому назначению',
				a3: 'Разметка для валидации HTML',
				a4: 'Специальная разметка для мобильных устройств',
			},
			answerOption: 'a2',
			answer: 'Семантическая разметка - использование HTML-тегов согласно их\n' +
				'смысловому значению (<nav>, <article>, <header>). Улучшает доступность,\n' +
				'SEO и поддерживаемость кода.',
			num: '#44',
		},
		{
			question: 'Какой атрибут позволяет указать несколько значений для <input type="email">?',
			option: {
				a1: 'multiple',
				a2: 'multi',
				a3: 'many',
				a4: 'array',
			},
			answerOption: 'a1',
			answer: 'Атрибут multiple позволяет вводить несколько email-адресов через запятую\n' +
				'в поле <input type="email">. Также работает с <input type="file"> для\n' +
				'выбора нескольких файлов.',
			num: '#45',
		},
		{
			question: 'Что делает тег <picture> и чем он отличается от <img>?',
			option: {
				a1: 'Создает галерею изображений',
				a2: 'Позволяет указать несколько источников изображения для разных условий',
				a3: 'Добавляет рамку вокруг изображения',
				a4: 'Сжимает изображение',
			},
			answerOption: 'a2',
			answer: 'Тег <picture> позволяет указать несколько источников изображения через\n' +
				'<source> для разных разрешений экрана, форматов или медиа-запросов,\n' +
				'обеспечивая адаптивность.',
			num: '#46',
		},
		{
			question: 'Какой тег используется для создания диалогового окна в HTML5?',
			option: {
				a1: '<modal>',
				a2: '<dialog>',
				a3: '<popup>',
				a4: '<window>',
			},
			answerOption: 'a2',
			answer: 'Тег <dialog> создает нативное диалоговое окно. Методы showModal() и\n' +
				'show() открывают его как модальное или немодальное окно. Метод close()\n' +
				'закрывает диалог.',
			num: '#47',
		},
		{
			question: 'Что означает атрибут autocomplete="off" в формах?',
			option: {
				a1: 'Отключает автоматическую отправку формы',
				a2: 'Отключает автозаполнение полей браузером',
				a3: 'Отключает валидацию формы',
				a4: 'Отключает возможность ввода',
			},
			answerOption: 'a2',
			answer: 'Атрибут autocomplete="off" отключает автозаполнение полей формы\n' +
				'браузером на основе ранее введенных данных. Может применяться к <form>\n' +
				'или отдельным <input>.',
			num: '#48',
		},
		{
			question: 'Какой тег используется для создания выделенного (подсвеченного) текста?',
			option: {
				a1: '<highlight>',
				a2: '<mark>',
				a3: '<em>',
				a4: '<selected>',
			},
			answerOption: 'a2',
			answer: 'Тег <mark> используется для выделения или подсветки текста, обычно\n' +
				'отображается желтым фоном. Семантически означает текст, имеющий отношение\n' +
				'к текущему контексту.',
			num: '#49',
		},
		{
			question: 'Что такое ARIA-атрибуты и для чего они используются?',
			option: {
				a1: 'Атрибуты для анимации элементов',
				a2: 'Атрибуты для улучшения доступности веб-приложений',
				a3: 'Атрибуты для валидации форм',
				a4: 'Атрибуты для адаптивного дизайна',
			},
			answerOption: 'a2',
			answer: 'ARIA (Accessible Rich Internet Applications) - набор атрибутов для\n' +
				'улучшения доступности веб-приложений для людей с ограниченными\n' +
				'возможностями, особенно при использовании программ чтения с экрана.',
			num: '#50',
		},
		{
			question: 'Какой атрибут тега <iframe> улучшает безопасность?',
			option: {
				a1: 'secure',
				a2: 'sandbox',
				a3: 'protected',
				a4: 'noexec',
			},
			answerOption: 'a2',
			answer: 'Атрибут sandbox ограничивает возможности встроенного фрейма:\n' +
				'запрещает выполнение скриптов, отправку форм и другие действия,\n' +
				'если явно не разрешено.',
			num: '#51',
		},
		{
			question: 'Что делает атрибут defer у тега <script>?',
			option: {
				a1: 'Загружает и выполняет скрипт немедленно',
				a2: 'Выполняет скрипт после загрузки HTML и в порядке объявления',
				a3: 'Загружает скрипт только при взаимодействии пользователя',
				a4: 'Откладывает загрузку скрипта до полной загрузки изображений',
			},
			answerOption: 'a2',
			answer: 'Атрибут defer загружает скрипт параллельно с HTML, но выполняет\n' +
				'его только после полной загрузки DOM, сохраняя порядок объявления.',
			num: '#52',
		},
		{
			question: 'Какой тег используется для вставки видео в HTML5?',
			option: {
				a1: '<media>',
				a2: '<video>',
				a3: '<movie>',
				a4: '<source>',
			},
			answerOption: 'a2',
			answer: 'Тег <video> встраивает видео в страницу. Внутри могут быть\n' +
				'теги <source> для указания нескольких форматов, а также fallback-контент.',
			num: '#53',
		},
		{
			question: 'Зачем используется атрибут role в HTML?',
			option: {
				a1: 'Для стилизации элементов',
				a2: 'Для улучшения SEO',
				a3: 'Для указания семантической роли элемента вспомогательным технологиям',
				a4: 'Для привязки JavaScript-обработчиков',
			},
			answerOption: 'a3',
			answer: 'Атрибут role из ARIA задаёт семантическую роль элемента для\n' +
				'программ чтения с экрана и других вспомогательных технологий,\n' +
				'улучшая доступность.',
			num: '#54',
		},
		{
			question: 'Какой тег позволяет задать базовый URL для всех относительных ссылок?',
			option: {
				a1: '<base>',
				a2: '<url>',
				a3: '<link>',
				a4: '<meta>',
			},
			answerOption: 'a1',
			answer: 'Тег <base> в <head> устанавливает базовый URL для всех\n' +
				'относительных ссылок и путей на странице. Должен быть только один.',
			num: '#55',
		},
		{
			question: 'Что такое «режим совместимости» (quirks mode) в браузере?',
			option: {
				a1: 'Режим отладки для разработчиков',
				a2: 'Режим, эмулирующий поведение старых браузеров при отсутствии DOCTYPE',
				a3: 'Режим для открытия устаревших сайтов',
				a4: 'Автоматическое исправление HTML-ошибок',
			},
			answerOption: 'a2',
			answer: 'Quirks mode — режим обратной совместимости, который браузер\n' +
				'включает при отсутствии или некорректном <!DOCTYPE>. В нём нарушаются\n' +
				'стандарты CSS- и HTML-разметки.',
			num: '#56',
		},
		{
			question: 'Какой атрибут <form> определяет метод отправки данных?',
			option: {
				a1: 'action',
				a2: 'method',
				a3: 'type',
				a4: 'enctype',
			},
			answerOption: 'a2',
			answer: 'Атрибут method задаёт HTTP-метод отправки формы: GET или POST.\n' +
				'Атрибут action указывает URL, на который отправляются данные.',
			num: '#57',
		},
		{
			question: 'Можно ли использовать несколько тегов <header> на одной странице?',
			option: {
				a1: 'Нет, только один',
				a2: 'Да, по одному на секцию или статью',
				a3: 'Только если они в разных <section>',
				a4: 'Только в HTML5.2 и выше',
			},
			answerOption: 'a2',
			answer: 'Да. Тег <header> может использоваться многократно: для всего\n' +
				'документа, а также для отдельных секций, статей или других блоков,\n' +
				'имеющих собственную «шапку».',
			num: '#58',
		},
		{
			question: 'Что делает атрибут integrity у тега <script> или <link>?',
			option: {
				a1: 'Шифрует содержимое скрипта',
				a2: 'Проверяет целостность загружаемого ресурса с помощью хеша',
				a3: 'Блокирует выполнение сторонних скриптов',
				a4: 'Ускоряет загрузку CDN-ресурсов',
			},
			answerOption: 'a2',
			answer: 'Атрибут integrity (SRI — Subresource Integrity) проверяет,\n' +
				'соответствует ли загруженный ресурс (например, с CDN) ожидаемому\n' +
				'хешу, защищая от подмены содержимого.',
			num: '#59',
		},
		{
			question: 'Какой тег лучше использовать для навигации по сайту?',
			option: {
				a1: '<div class="nav">',
				a2: '<nav>',
				a3: '<menu>',
				a4: '<section>',
			},
			answerOption: 'a2',
			answer: 'Тег <nav> — семантический элемент HTML5 для основных блоков\n' +
				'навигации. Улучшает доступность и SEO. Не все ссылки на странице\n' +
				'должны быть в <nav> — только ключевые.',
			num: '#60',
		},
	],
};

export default HTMLQuestions;
